export enum TenantIntegrationType {
  CertMetrics = 'CertMetrics',
}
